import { Directive, ElementRef, OnDestroy, Renderer2 } from '@angular/core';
import { DfEventService } from '@df/core/service/df-event';

import { Customer } from '@df/session/api/customer';
import { Subscription } from 'rxjs';
@Directive({
    selector: '[basketQtyBullet]',
    standalone: true
})
export class BasketQtyBulletDirective implements OnDestroy {
    private subscriptions = new Subscription();
    /**
     * In basket qty
     */
    private qty = 0;
    constructor(private customer: Customer, private renderer2: Renderer2, private elementRef: ElementRef, private dfEventService: DfEventService) { }
    ngOnInit(): void {
        this.subscriptions.add(
            this.dfEventService.success(event => {
                if (event.id === 'basketDataChange') {
                    this.update();
                }
            })
        );
        this.update();
    }
    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
    private update() {
        const qty = this.customer.basket.qty;
        if (this.qty !== qty) {
            this.qty = qty;
            if (qty) {
                this.renderer2.setAttribute(this.elementRef.nativeElement, 'qty-bullet', qty.toString());
            }
            else {
                this.renderer2.removeAttribute(this.elementRef.nativeElement, 'qty-bullet');
            }
            this.renderer2.setAttribute(this.elementRef.nativeElement, 'aria-label', `Basket quantity ${qty}`);
        }
    }
}
